import { weblinkFragment } from '../../../graphql/weblinkFragment';
import { graphql } from '../../../graphql/graphql';

export const seoFooterFragment = graphql(
  `
    fragment SeoFooterFragment on Footer {
      footerTabsV2 {
        title
        tabs {
          name
          tabContent {
            title
            links {
              ...WebLink
            }
          }
        }
      }
    }
  `,
  [weblinkFragment],
);
